import { render, staticRenderFns } from "./cont_five.vue?vue&type=template&id=28acb616&scoped=true"
import script from "./cont_five.vue?vue&type=script&lang=js"
export * from "./cont_five.vue?vue&type=script&lang=js"
import style0 from "./cont_five.vue?vue&type=style&index=0&id=28acb616&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28acb616",
  null
  
)

export default component.exports